import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyRole = {
  // 角色列表
  getRoleList(params) {
    return http.post(`${baseUrl}Role/list`, params)
  },
  // 获取权限列表
  getAllEnableMenu(params) {
    return http.post(`${baseUrl}Role/allEnableMenu`, params)
  },
  // 获取指定人权限
  getCheckedAuth(params) {
    return http.post(`${baseUrl}Role/getCheckedAuth`, params)
  },
  // 修改角色权限
  setAuth(params) {
    return http.post(`${baseUrl}Role/setAuth`, params)
  },
  // 新增/编辑角色
  addEditAuth(params) {
    return http.post(`${baseUrl}Role/addOrEdit`, params)
  },
  // 删除角色
  delEditAuth(params) {
    return http.post(`${baseUrl}Role/del`, params)
  },
}



// WEBPACK FOOTER //
// ./src/api/companyRole.js